// import { serverUrl } from '../config-client';

// Function to call the backend FHIR server with the B2C Auth token
// Used in all calls to FHIR server
export function callApiWithB2CToken(endpoint, token, headers, requestType, requestBody) {
  const bearer = `Bearer ${token}`;
  const requestConfig = {
    method: requestType,
    headers,
    credentials: 'include',
  };
  headers.append('Authorization', bearer);
  if (requestType === 'POST') {
    requestConfig.body = requestBody;
  }
  return fetch(endpoint, requestConfig)
  .then(response => {
    return response;
  })
    .catch((error) => {
      return null;
    });
}



// WEBPACK FOOTER //
// ./src/actions/callApi.js